export enum ThemesActions {
  UPDATE_CURRICULA_SELECTED = 'updateCurriculaSelected',
}